import lifecycleURL from "../../../../../docs/assets/survey-lifecycle.jpg";
import * as React from 'react';
export default {
  lifecycleURL,
  React
};